import {
  Directive,
  Output,
  Input,
  EventEmitter,
  HostBinding,
  HostListener
} from '@angular/core';

/** Drag and drop directive providing drag and drop events */

@Directive({
  selector: '[appDnd]',
  standalone: false
})
export class DndDirective {
  @HostBinding('class.fileover') fileOver: boolean = false;
  @Output() fileDropped = new EventEmitter<any>();
  private dragging: number = 0;

  /** Dragenter listener */ 
  @HostListener('dragenter', ['$event']) onDragEnter(evt: any) {
    this.dragging++;
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  /** Dragover listener */ 
  @HostListener('dragover', ['$event']) onDragOver(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  /** Dragleave listener */
  @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {

    this.dragging--;
    
    evt.preventDefault();
    evt.stopPropagation();
    if (this.dragging === 0) {
      this.fileOver = false;
    }
  }

  /** Drop listener */
  @HostListener('drop', ['$event']) public ondrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}